import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { openEditCallerNameDialog } from '../../actions';

export type CallerFullNamePanelProps = {
  incidentId: string;
  callerFullName: string | null;
  editable?: boolean;
};

export function CallerFullNamePanel({ incidentId, callerFullName, editable = false }: CallerFullNamePanelProps) {
  const { t } = useTranslation();

  return (
    <DataPanelInlineItem
      title={t('Incident_InfoPanel_Name')}
      value={callerFullName ?? undefined}
      editable={editable}
      showEmptyPlaceholder
      onEditClick={() => openEditCallerNameDialog(incidentId, callerFullName)}
    />
  );
}
